import React from 'react';
import { useTranslation } from 'react-i18next';
import { MapPin, Phone, Mail, Globe, Users, Edit } from 'lucide-react';
import {Company} from "../../model/professional/compagny-model";

// Types
interface CompanyDetailsProps {
  company: Company | null
  onEdit: () => void;
  onViewCollaborators: () => void;
}

const CompanyDetails: React.FC<CompanyDetailsProps> = ({ company, onEdit, onViewCollaborators }) => {
  const { t } = useTranslation();
  
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-start">
        <h2 className="text-xl font-semibold">
          {t('company.details.title', 'Détails de l\'entreprise')}
        </h2>
        <button 
          onClick={onEdit}
          className="flex items-center gap-2 px-3 py-2 bg-primary text-white rounded-md hover:bg-primary-dark transition-colors"
        >
          <Edit size={16} />
          <span>{t('company.details.edit', 'Modifier')}</span>
        </button>
      </div>
      
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow overflow-hidden">
        {/* En-tête avec logo et nom */}
        <div className="p-6 border-b border-gray-200 dark:border-gray-700">
          <div className="flex items-center space-x-4">
            <div className="flex-shrink-0">
              <img 
                src={company?.companyLogo || '/avatar-placeholder.jpg'}
                alt={company?.businessName}
                className="h-16 w-16 rounded-full object-cover border-2 border-gray-200 dark:border-gray-700" 
              />
            </div>
            <div>
              <h3 className="text-lg font-medium text-gray-900 dark:text-white">
                {company?.businessName}
              </h3>
              <div className="mt-1 flex items-center">
                <button 
                  onClick={onViewCollaborators}
                  className="text-sm text-primary hover:underline flex items-center gap-1"
                >
                  <Users size={14} />
                  <span>
                    {company?.collaboratorsCount} {Number(company?.collaboratorsCount) > 1
                      ? t('company.details.collaboratorsPlural', 'collaborateurs') 
                      : t('company.details.collaboratorsSingular', 'collaborateur')}
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
        
        {/* Informations de contact */}
        <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-3">
              {t('company.details.contactInfo', 'Informations de contact')}
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start">
                <MapPin className="h-5 w-5 text-gray-400 mr-2 mt-0.5" />
                <span className="text-gray-700 dark:text-gray-300">
                  {company?.address}<br />
                  {company?.postalCode} {company?.city}
                </span>
              </li>
              
              {/*{company?. && (
                <li className="flex items-center">
                  <Phone className="h-5 w-5 text-gray-400 mr-2" />
                  <span className="text-gray-700 dark:text-gray-300">{company.phone}</span>
                </li>
              )}*/}
              
              {/*<li className="flex items-center">
                <Mail className="h-5 w-5 text-gray-400 mr-2" />
                <span className="text-gray-700 dark:text-gray-300">{company?.email}</span>
              </li>*/}
            </ul>
          </div>
          
          {company?.description && (
            <div>
              <h4 className="text-sm font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-3">
                {t('company.details.description', 'Description')}
              </h4>
              <p className="text-gray-700 dark:text-gray-300 whitespace-pre-line">
                {company.description}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CompanyDetails;
